import { autoUpdate, computePosition, flip } from '@floating-ui/dom';
export class MultilingualContainerPosition {
    constructor(multilingualContainer) {
        this.hasScrollBar = false;
        this.updatePosition = () => {
            void computePosition(this.input, this.multilingualContainer.getContainer(), {
                middleware: [flip()],
            }).then(({ x, y, placement }) => {
                this.multilingualContainer.getContainer().style.left = `${x}px`;
                this.multilingualContainer.getContainer().style.top = `${y}px`;
                this.inputRect = this.input.getBoundingClientRect();
                if (placement === 'bottom') {
                    this.moveContainerUp(y);
                }
                else if (placement === 'top') {
                    this.moveContainerDown(y);
                }
                this.calculateWidth();
                if (this.hasScrollBar) {
                    this.adjustContainerPositionWithScroll(x);
                }
                this.multilingualContainer.handleShadowStyle();
            });
        };
        this.multilingualContainer = multilingualContainer;
    }
    initContainerPosition(input) {
        this.input = input;
        this.inputRect = this.input.getBoundingClientRect();
        this.setContainerWidth();
        this.cleanUp = autoUpdate(this.input, this.multilingualContainer.getContainer(), this.updatePosition);
    }
    stopContainerPosition() {
        this.hasScrollBar = false;
        if (this.cleanUp) {
            this.cleanUp();
        }
    }
    setContainerWidth(expandWidth = 0) {
        this.multilingualContainer.getContainer().style.width = `${this.inputRect.width + MultilingualContainerPosition.CONTAINER_PADDING + expandWidth}px`;
    }
    moveContainerUp(y) {
        const mainInputTop = this.inputRect.top;
        const containerInputTop = this.multilingualContainer
            .getInputByLanguage()
            .getBoundingClientRect().top;
        this.multilingualContainer.getContainer().style.top = `${mainInputTop - Math.abs(containerInputTop - y)}px`;
        this.multilingualContainer.getContainer().style.position = 'fixed';
    }
    moveContainerDown(y) {
        const mainInputBottom = this.inputRect.bottom;
        const containerBottom = this.multilingualContainer
            .getContainer()
            .getBoundingClientRect().bottom;
        if (!this.offsetBottom) {
            this.offsetBottom = Math.abs(containerBottom - mainInputBottom);
        }
        this.multilingualContainer.getContainer().style.top = `${y + this.offsetBottom}px`;
    }
    adjustContainerPositionWithScroll(x) {
        const value = this.input.getBoundingClientRect().left -
            this.multilingualContainer.getInputByLanguage().getBoundingClientRect().left;
        this.multilingualContainer.getContainer().style.left = `${x + value}px`;
    }
    calculateWidth() {
        this.handleInputWidthChange();
        if (this.multilingualContainer.contentContainerOverflows() && !this.hasScrollBar) {
            this.hasScrollBar = true;
            this.setContainerWidth(this.multilingualContainer.getScrollBarWidth());
        }
        else if (!this.multilingualContainer.contentContainerOverflows() && this.hasScrollBar) {
            this.hasScrollBar = false;
            this.setContainerWidth();
        }
    }
    handleInputWidthChange() {
        const inputWidth = this.input.clientWidth;
        const containerInputWidth = this.multilingualContainer.getInputByLanguage().clientWidth;
        if (containerInputWidth !== inputWidth) {
            this.multilingualContainer.getContainer().style.width = `${this.multilingualContainer.getContainer().clientWidth +
                (inputWidth - containerInputWidth)}px`;
        }
    }
}
MultilingualContainerPosition.CONTAINER_PADDING = 32;
